export const accordionNITG = (attrClass = '') => {
    const selector = `${attrClass} .accordion`;
    const accordions = document.querySelectorAll(selector);
    if (!accordions.length) return;
    
    accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll('.accordion-item');
        
        items.forEach((item, index) => {
            const title = item.querySelector('.accordion-item__question');
            const content = item.querySelector('.accordion-item__answer');
            
            const contentId = `accordion-content-${index}`;
            const titleId = `accordion-question-${index}`;
            
            // Initial ARIA
            title?.setAttribute('id', titleId);
            title?.setAttribute('aria-controls', contentId);
            title?.setAttribute('aria-expanded', item.classList.contains('show') ? 'true' : 'false');
            title?.setAttribute('role', 'button');
            title?.setAttribute('tabindex', '0');
            
            content?.setAttribute('id', contentId);
            content?.setAttribute('role', 'region');
            content?.setAttribute('aria-labelledby', titleId);
            
            // Apply initial open state
            if (item.classList.contains('show')) {
                content.style.maxHeight = content.scrollHeight + 20 + 'px';
                content.style.paddingBottom = '20px'; // ← замените на ваш миксин-паддинг в px
            } else {
                content.style.maxHeight = null;
                content.style.paddingBottom = '0';
            }
            
            // Toggle logic
            const toggleItem = () => {
                const isOpen = item.classList.contains('show');
                
                // Закрыть все
                items.forEach((otherItem) => {
                    const otherTitle = otherItem.querySelector('.accordion-item__question');
                    const otherContent = otherItem.querySelector('.accordion-item__answer');
                    
                    otherItem.classList.remove('show');
                    otherTitle?.setAttribute('aria-expanded', 'false');
                    
                    if (otherContent) {
                        otherContent.style.maxHeight = null;
                        otherContent.style.paddingBottom = '0';
                    }
                });
                
                // Открыть выбранный
                if (!isOpen) {
                    item.classList.add('show');
                    title?.setAttribute('aria-expanded', 'true');
                    
                    if (content) {
                        // Принудительно сбрасываем, чтобы пересчитать scrollHeight
                        content.style.maxHeight = '0';
                        content.style.paddingBottom = '0';
                        
                        // Подождать один кадр (иначе анимация не сработает)
                        requestAnimationFrame(() => {
                            content.style.paddingBottom = '20px'; // ← ваш реальный padding
                            content.style.maxHeight = content.scrollHeight + 20 + 'px';
                        });
                    }
                }
            };
            
            title?.addEventListener('click', toggleItem);
            title?.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleItem();
                }
            });
        });
    });
};